<template>
	<el-dialog
		:modelValue="open"
		@update:modelValue="$emit('update:open', $event)"
		:title="'Stellungnahme löschen'"
		align-center
		:before-close="(done) => dialogBeforeClose(done, waiting)"
	>
		<el-alert type="error" :closable="false" effect="dark" show-icon>
			<template #title>
				<strong>Die Stellungnahme wird permanent gelöscht.</strong> Nach Löschung der Stellungnahme können Sie auf die Inhalte nicht mehr zugreifen.
			</template>
		</el-alert>

		<el-alert :title="errorMsg" type="error" v-if="error" />

		<template #footer>
			<div class="button-panel">
				<TheButton type="danger" @buttonclick="handleDelete" :disabled="waiting">Löschen</TheButton>
				<TheButton type="default" @buttonclick="$emit('close')">Abbrechen</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TheButton from '../TheButton.vue';
import { texts } from '../../utils/texts';
import { dialogBeforeClose } from '@/utils/functions';
import { deleteStatement } from '@/requests/statements';

export default defineComponent({
	name: 'DialogDeleteComplaint',
	data() {
		return {
			waiting: false,
			error: false,
			errorMsg: texts.statements.deleteFailed,
		};
	},
	components: {
		TheButton,
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
		statementId: {
			type: String,
			required: true,
		},
		caseId: {
			type: String,
			required: true,
		},
	},
	emits: ['close', 'update:open'],
	methods: {
		async handleDelete() {
			this.waiting = true;
			const deletionResult = await deleteStatement(this.statementId);
			if (deletionResult.success) {
				this.$router.push({ name: 'FallDetail', params: { id: String(this.caseId) } });
			} else {
				this.error = true;
			}

			this.waiting = false;
		},
		dialogBeforeClose,
	},
	mounted() {},
});
</script>
